import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function AssociatePortal() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('associate.title')}
      subtitle={t('associate.subtitle')}
    >
      <h2>{t('associate.forAssociates')}</h2>
      <p>{t('associate.forAssociatesCopy1')}</p>
      <p>
        {t('associate.forAssociatesCopyBefore')}{' '}
        <a href="mailto:it-support@starviewcinema.com">it-support@starviewcinema.com</a>
        {t('associate.forAssociatesCopyAfter')}
      </p>

      <h2>{t('associate.lookingToJoin')}</h2>
      <p>
        {t('associate.lookingToJoinCopyBefore')} <a href="/careers">{t('associate.careersLink')}</a>{' '}
        {t('associate.lookingToJoinCopyMid')} <a href="/drive">{t('associate.driveLink')}</a>
        {t('associate.lookingToJoinCopyAfter')}
      </p>
    </InfoPage>
  );
}
